<template>
  <div class="document-assign-component" :class="{ 'user-specific': selectedType === 'User' }">
    <div class="form-group">
      <label for="type">Type</label>
      <select v-model="selectedType" class="form-control"
              :name="'documentables[' + index + '][type]'" id="type">
        <option :value="null">Everyone</option>
        <option v-for="type in types" :key="type" :value="type">
          {{ type }}
        </option>
      </select>
    </div>

    <!-- Development -->
    <div v-if="selectedType === 'Development'" class="form-group">
      <label for="development">Development</label>
      <select v-model="selectedDevelopment" class="form-control" :name="'documentables[' + index + '][development]'"
              id="development">
        <option :value="null">Select development</option>
        <option v-for="development in developments" :key="development.id" :value="development">
          {{ development.name }}
        </option>
      </select>
    </div>

    <!-- House Type -->
    <div v-if="selectedType === 'House Type'" class="form-group">
      <label for="development">House Type</label>
      <select v-model="selectedHouseType" class="form-control" :name="'documentables[' + index + '][house_type]'"
              id="house_type">
        <option :value="null">Select house type</option>
        <option v-for="houseType in houseTypes" :key="houseType.id" :value="houseType">
          {{ houseType.name }}{{ houseType.revision ? ' - ' + houseType.revision : '' }}
        </option>
      </select>
    </div>

    <!-- Development specific house type -->
    <div v-if="selectedType === 'Development' && selectedDevelopment" class="form-group">
      <label for="house_type">House Type</label>
      <select v-model="selectedDevelopmentHouseType" class="form-control"
              :name="'documentables[' + index + '][development_house_type]'"
              id="house_type">
        <option :value="null">All house types</option>
        <option v-for="houseType in selectedDevelopment.house_types" :key="houseType.id" :value="houseType">
          {{ houseType.name }}
        </option>
      </select>
    </div>

    <!-- Development specific plot -->
    <div v-if="selectedType === 'Development' && selectedDevelopment && selectedDevelopmentHouseType"
         class="form-group">
      <label for="plot">House</label>
      <select v-model="selectedPlot" class="form-control" :name="'documentables[' + index + '][plot]'" id="plot">
        <option :value="null">All plots</option>
        <option
          v-for="plot in selectedDevelopment.plots.filter(p => p.development_house_type_id === selectedDevelopmentHouseType.development_house_type_id)"
          :key="plot.id" :value="plot">
          {{ plot.name_number }}
        </option>
      </select>
    </div>

    <div v-if="selectedType === 'User'" class="form-group">
      <label for="user">User</label>
      <select v-model="selectedUser" class="form-control" :name="'documentables[' + index + '][user]'"
              id="user">
        <option :value="null">Select user</option>
        <option v-for="user in users" :key="user.id" :value="user">
          {{ user.name }} - {{ user.email }}
        </option>
      </select>
    </div>

    <input v-model="documentableId" type="hidden" :name="'documentables[' + index + '][documentable_id]'"/>
    <input v-model="documentableType" type="hidden" :name="'documentables[' + index + '][documentable_type]'"/>
    <hr>
    <p v-on:click="removeAssignment" class="text-right">Remove Assignment</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      types: ["Development", "House Type", "User"],
      selectedType: null,
      selectedDevelopment: null,
      selectedHouseType: null,
      selectedDevelopmentHouseType: null,
      selectedUser: null,
      selectedPlot: null,
      documentableId: null,
      documentableType: null,
      confirmedNonSensitive: false,
    };
  },

  props: {
    developments: {
      type: Array,
      default: null,
    },
    users: {
      type: Array,
      default: null,
    },
    preloadDocumentableId: {
      type: Number,
      default: null,
    },
    preloadDocumentableType: {
      type: String,
      default: null,
    },
    preloadDocumentable: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: null
    },
    documentId: {
      type: Number
    }
  },

  computed: {
    houseTypes() {
      if (this.developments) {
        // Pick out unique house types from each development.
        let houseTypes = this.developments.map((development) => {
          return development.house_types;
        })
          .flat()
          .filter((houseType, index, self) => {
            return index === self.findIndex((t) => (
              t.id === houseType.id
            ));
          });

        // Convert development_house_type_id to integer.
        houseTypes.forEach((houseType) => {
          houseType.development_house_type_id = parseInt(houseType.development_house_type_id);
        });

        // Sort.
        houseTypes.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });

        return houseTypes;
      }

      return [];
    }
  },

  watch: {
    selectedType: function (newValue, oldValue) {
      this.selectedDevelopment = null;
      this.selectedHouseType = null;
      this.selectedDevelopmentHouseType = null;
      this.selectedPlot = null;
      this.selectedUser = null;

      this.documentableId = null;
      this.documentableType = null;
    },

    selectedDevelopment: function (newValue, oldValue) {
      this.selectedHouseType = null;
      this.selectedDevelopmentHouseType = null;
      this.selectedUser = null;

      if (newValue) {
        this.documentableId = newValue.id;
        this.documentableType = "App\\Models\\Development";
      } else {
        this.documentableId = null;
        this.documentableType = null;
      }
    },

    selectedHouseType: function (newValue, oldValue) {
      this.selectedUser = null;
      this.selectedDevelopment = null;
      this.selectedDevelopmentHouseType = null;
      this.selectedPlot = null;

      if (newValue) {
        this.documentableId = newValue.id;
        this.documentableType = "App\\Models\\HouseType";
      } else {
        this.documentableId = null;
        this.documentableType = null;
      }
    },

    selectedDevelopmentHouseType: function (newValue, oldValue) {
      this.selectedUser = null;
      this.selectedHouseType = null;

      if (newValue) {
        this.documentableId = newValue.development_house_type_id;
        this.documentableType = "App\\Models\\DevelopmentHouseType";
      } else if (this.selectedDevelopment) {
        this.documentableId = this.selectedDevelopment.id;
        this.documentableType = "App\\Models\\Development";
      } else {
        this.documentableId = null;
        this.documentableType = null;
      }
    },

    selectedPlot: function (newValue, oldValue) {
      this.selectedUser = null;
      this.selectedHouseType = null;

      if (newValue) {
        this.documentableId = newValue.id;
        this.documentableType = "App\\Models\\Plot";
      } else if (this.selectedDevelopmentHouseType) {
        this.documentableId = this.selectedDevelopmentHouseType.id;
        this.documentableType = "App\\Models\\DevelopmentHouseType";
      } else if (this.selectedDevelopment) {
        this.documentableId = this.selectedDevelopment.id;
        this.documentableType = "App\\Models\\Development";
      } else {
        this.documentableId = null;
        this.documentableType = null;
      }
    },

    selectedUser: function (newValue, oldValue) {
      this.selectedDevelopment = null;
      this.selectedHouseType = null;
      this.selectedDevelopmentHouseType = null;

      if (newValue) {
        this.documentableId = newValue.id;
        this.documentableType = "App\\Models\\User";
      } else {
        this.documentableId = null;
        this.documentableType = null;
      }
    },
  },

  created() {
    if (this.preloadDocumentableId !== null && this.preloadDocumentableType) {
      this.preloadDocumentableId = parseInt(this.preloadDocumentableId);

      if (this.preloadDocumentableType === "App\\Models\\User") {
        this.selectedType = "User";

        this.$nextTick(() => {
          this.selectedUser = this.users.filter(
            (user) => user.id === this.preloadDocumentableId
          )[0];
        });
      } else {
        if (this.preloadDocumentable !== null) {
          this.selectedType = this.preloadDocumentableType === "App\\Models\\HouseType" ? "House Type" : "Development";

          // Plot?
          if (this.preloadDocumentableType === 'App\\Models\\Plot') {
            this.preloadDevelopment().then(() => {
              this.preloadDevelopmentHouseType().then(() => {
                this.preloadPlot();
              });
            });
          }

          // House Type?
          if (this.preloadDocumentableType === 'App\\Models\\HouseType') {
            this.preloadHouseType();
          }

          // Development House Type?
          if (this.preloadDocumentableType === 'App\\Models\\DevelopmentHouseType') {
            this.preloadDevelopment().then(() => {
              this.preloadDevelopmentHouseType();
            });
          }

          // Development?
          if (this.preloadDocumentableType === 'App\\Models\\Development') {
            this.preloadDevelopment();
          }
        }
      }
    }

    // Nothing selected? Pre-select "User" type.
    /*if (this.selectedType === null) {
      this.selectedType = "User";
    }*/
  },

  methods: {
    preloadDevelopment() {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          resolve(this.selectedDevelopment = this.developments.find(development => development.id === (this.preloadDocumentable.development_id || this.preloadDocumentableId)));
        });
      });
    },

    preloadDevelopmentHouseType() {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          resolve(this.selectedDevelopmentHouseType = this.selectedDevelopment.house_types.find(houseType => houseType.id === (this.preloadDocumentable.house_type_id || this.preloadDocumentableId)));
        });
      });
    },

    preloadHouseType() {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          console.log('parseInt(this.preloadDocumentableId || this.preloadDocumentable.house_type_id) = ' + parseInt(this.preloadDocumentableId || this.preloadDocumentable.house_type_id));
          console.log('first house type id = ' + this.houseTypes[0].id);

          resolve(
            this.selectedHouseType = this.houseTypes.find(
              houseType => parseInt(houseType.id) === parseInt(this.preloadDocumentableId || this.preloadDocumentable.house_type_id)
            )
          );
        });
      });
    },

    preloadPlot() {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          resolve(this.selectedPlot = this.selectedDevelopment.plots.find(plot => plot.id === this.preloadDocumentable.id));
        });
      });
    },
    removeAssignment() {
      axios.post(`${window.api_url}/admin/documents/unassign`, {
        'document_id': this.documentId,
        'documentable_type': this.documentableType,
        'documentable_id': this.documentableId
      })
        .then(response => {
          this.$emit('remove-assignment', this.index);
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
};
</script>
